import * as Sentry from '@sentry/react'

const GENERIC_ERROR = 'Stiamo riscontrando un problema e ci stiamo lavorando. Riprova più tardi.'

export function reportError(e: unknown): string {
  Sentry.captureException(e)
  return GENERIC_ERROR
}
